import { Component } from './Component';

export type ComponentPolicyResult = [true] | [false, string];

export interface ComponentPolicy {

    allowAdd(child: Component): ComponentPolicyResult;

    allowRemove(child: Component): ComponentPolicyResult;

    allowSet(property: string, value: any): ComponentPolicyResult;
}

const createPolicy = (rules: Partial<ComponentPolicy>): ComponentPolicy => {
    const base = {
        allowAdd: () => [true],
        allowRemove: () => [true],
        allowSet: () => [true],
    };
    return Object.assign(base, rules);
};

export const ComponentPolicy = {
    create: createPolicy,
    default: createPolicy({}),
    restricted: (...types: string[]) => createPolicy({
        allowAdd: (child) => !!types.includes(child.type) ? [true] : [false, `Cannot add ${child.type} to this component`],
    }),
    noChildren: (type: string) => createPolicy({
        allowAdd: (() => [false, `${type} does not support child components.`])
    })
};
